import { Skeleton } from '@components/ui/skeleton';
import { useProcesses } from '@hooks/useProcesses';
import type { ProcessModel } from '@models/process.model';
import { useNavigate, useParams } from 'react-router-dom';

import { ParamsList } from '@/routes/routes.types';

import { HeaderDropdown } from './headerDropdown';

export const ProcessSelector = () => {
  const navigate = useNavigate();

  const processId = useParams()[ParamsList.ProcessId] as string;
  const { loading, processes } = useProcesses();

  const process = processes.find(p => p.id === processId);

  const dropdownItems = processes.map(process => ({
    id: process.id,
    name: process.name,
    tag: process.tag,
    icon: process.icon
  }));

  const changeProcess = (processId: ProcessModel['id']) => {
    navigate(`/${processId}/general`);
  };

  if (loading) {
    return <Skeleton className="h-[20px] w-[100px]" />;
  }

  if (!process) {
    return null;
  }

  return (
    <HeaderDropdown
      currentItemId={processId}
      items={dropdownItems}
      onSelect={changeProcess}
      type="process"
    />
  );
};
